<template>
  <basic-dialog :show="show" @close="$emit('close')" max-width="1200">
    <template v-slot:title>Contents</template>
    <contents :owner-id="ownerId" :owner-name="ownerName"></contents>
  </basic-dialog>
</template>

<script>
import BasicDialog from "../BasicDialog.vue";
import Contents from "./Contents.vue";
export default {
  components: { BasicDialog, Contents },
  name: "contents-dialog",
  props: {
    ownerId: {
      type: String,
      required: true,
    },
    ownerName: {
      type: String,
      default: () => "",
    },
    show: {
      type: Boolean,
      default: () => false,
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/shared/contents/ContentsDialog.vue